import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-subproducts-discover-difference',
  templateUrl: './discover-difference.component.html',
  styleUrls: ['./discover-difference.component.scss'],
  imports: [CommonModule],
})
export class CommonSubProductsDiscoverDifferenceComponent implements OnInit {
  @Input() differenceData: any;
  @Input() customClass: any;
  @Input() isInside: any;
  constructor() {}
  _differenceData: any;
  ngOnInit(): void {
    this._differenceData = this.differenceData;
  }
  ngOnChanges(): void {
    this._differenceData = this.differenceData;
  }
}
